export const CAT_NAME = {
    1: 'Blog',
    9: 'News'
}